import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useMutation } from "react-query";

import Loader from "../../components/Loader";
import PasswordVerificationSuccess from "./PasswordVerificationSuccess";

import { setLocalCredentials } from "../../helpers/authHelpers";
import { useAuth } from "../../services/wp.auth.service";
import verifyEmailMutation from "./registration/verifyEmailMutation";

const VerifyEmail = () => {
	const [loading, setLoading] = useState(true);
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();
	const { refetchUser } = useAuth();

	const username = searchParams.get("username");
	const verificationKey = searchParams.get("verificationKey");
	const newEmail = searchParams.get("email");

	const {
		mutate
	} = verifyEmailMutation(useMutation, {
		onError: (error) => {
			navigate("/login", {
				state: {
					message: error.message || "Email verification failed. Please try the Forgot Password link below.",
					variant: "danger"
				}
			});
		},
		onSuccess: async ({ data }) => {

			const { success, user } = data.data.verifyUserEmail;

			if (success) {
				const { email, jwtAuthToken, jwtRefreshToken } = user;
				setLocalCredentials(email, jwtAuthToken, jwtRefreshToken);
				await refetchUser();

				if (newEmail) {
					navigate("/account/manage", {
						state: {
							message: "New email successfully verified."
						}
					});
				}

				setLoading(false);
			} else {
				navigate("/login", {
					state: {
						message: "Email verification failed. Please try the Forgot Password link below.",
						variant: "danger"
					}
				});
			}
		}
	});

	useEffect(() => {
		if (!username || !verificationKey) {
			navigate("/login");
		} else {
			const vars = {
				username,
				verificationKey
			};
			if (newEmail) {
				vars.email = newEmail;
			}
			mutate(vars);
		}
	}, []);

	return loading
		? <Loader />
		: <PasswordVerificationSuccess />;
};

export default VerifyEmail;
